/**
 * Feature Flag CrossFrame Listeners
 *
 * Handles CrossFrame requests for feature flag operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetFeatureFlagValueInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetFeatureFlagValueInput'
import { GetFeatureFlagValueOutput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetFeatureFlagValueOutput'
import { HasElevatedPermissionsInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/HasElevatedPermissionsInput'
import { HasElevatedPermissionsOutput } from '@amzn/coral_com-amazon-ihmvirgo-coral/HasElevatedPermissionsOutput'
import { validateRequired } from './listenerUtils'

export async function getFeatureFlagListener (message: any): Promise<GetFeatureFlagValueOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'flagName', 'storeId')
    const client = getServiceClient()
    return client.getFeatureFlagValue(GetFeatureFlagValueInput.clone(params)).toPromise()
}

export async function hasElevatedPermissionsListener (message: any): Promise<HasElevatedPermissionsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.hasElevatedPermissions(HasElevatedPermissionsInput.clone(params)).toPromise()
}
